import { Component, HostBinding, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../services/shared.service';
import { Constants } from '../constants';
import { ModuleNameEnum, Piwiktrack } from '../shared/piwiktrack';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  standalone: false
})
export class ErrorComponent implements OnInit, OnDestroy {
  @HostBinding('class') class = 'fullWith';

  public errorMessage: string = '';
  private reloadTimeoutId?: number;
  private destroy$ = new Subject<void>();

  constructor(private route: ActivatedRoute, private translate: TranslateService, private sharedService: SharedService) { }

  ngOnInit(): void {
    this.initTraductionError();
    this.reloadPage();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.reloadTimeoutId) {
      clearTimeout(this.reloadTimeoutId);
    }
  }

  public initTraductionError() {
    this.route.paramMap
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        const errorCode = params.get('errorCode');

        this.translate.get('ERROR').subscribe((translated: string) => {
          switch (errorCode) {
            case 'notAuthorized':
              this.errorMessage = this.translate.instant('ERROR.NOT_AUTHORIZED');
              break;
            case 'noNews':
              this.errorMessage = this.translate.instant('ERROR.NO_NEWS');
              break;
            default:
              this.errorMessage = this.translate.instant('ERROR.DEFAULT');
          }
        });
        this.sharedService.getToken().then(token => {
          Piwiktrack.piwikTrackPage(this.errorMessage, ModuleNameEnum.ErrorView, token);
        });
      });
  }

  private reloadPage(): void {
    this.sharedService.getToken().then(token => {
      this.reloadTimeoutId = window.setTimeout(() => {
        if (token) {
          this.sharedService.navigateByDisplayMode('home');
        }
        else {
          this.sharedService.navigate([Constants.RedirectUrl.Auth]);
        }
      }, (30000));
    });
  }
}